const middleware = {}

middleware['subDomain'] = require('../middleware/subDomain.js')
middleware['subDomain'] = middleware['subDomain'].default || middleware['subDomain']

export default middleware
